// byClaude-start 2026-07-01 16:01:07
import { CouponData, CouponIssueUserDto } from '@/interface/KKC/coupon';

/**
 * 将 CouponIssueUserDto 转换为 CouponData
 * @param item - 优惠券原始数据
 * @param idx - 可选索引，用于生成默认 id
 * @returns 转换后的优惠券数据
 */
export const transformCouponData = (item: CouponIssueUserDto, idx?: number): CouponData => ({
  validStartTime: item.validStartTime || '',
  validEndTime: item.validEndTime || '',
  type: item.couponMetaDto?.couponType || null,
  id: item.id || (idx !== undefined ? `local-${idx}` : 'local-0'),
  value: item.couponMetaDto?.param1 || 0,
  couponTaskDto: item.couponTaskDto || {},
  couponMetaDto: item.couponMetaDto || {},
  assignProductList: item.assignProductList || '',
  redemptionStatus: item.redemptionStatus,
  isExpire: item.isExpire || '',
  isRecovery: item.isRecovery || '',
  couponMetaI18nDto: item.couponMetaDto?.couponMetaI18nDto || null,
  isPreset: item.isPreset,
  expireFlag: item.expireFlag || '',
  remainingValidDays: item.remainingValidDays || 0,
  couponTypeDesc: item.couponTypeDesc || '',
  exchangeTime: item.exchangeTime || '',
  exchangeLocation: item.exchangeLocation || '',
  signCode: item.signCode || '',
});
// byClaude-end 2026-07-01 16:01:07
// Contains claude-generated edits.
